// extracted by mini-css-extract-plugin
export default {"or":"OrSeparator-or-cd2d0c8c564bad054e0835d79cc8240b"};